// extracted by mini-css-extract-plugin
export var chip = "_5j-0";
export var filterDropdown = "_5j-5";
export var filterItem = "_5j-6";
export var icon = "_5j-1";
export var removeButton = "_5j-3";
export var removeIcon = "_5j-4";
export var separator = "_5j-2";